module.exports = __webpack_public_path__ + "img/b-mask_construction-worker.d7b0ae7.png";